import { useMutation } from '@tanstack/react-query';
import { createAlternative } from "@/api/alternative"; 
import { CreateAlternativeRequest } from "@/types"; 
import { PostParam } from "@/types/index"; 

export function useCreateAlternative(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<any, Error, CreateAlternativeRequest>({
    mutationFn: createAlternative,
    onSuccess,
    onError
  });
}